export default __webpack_public_path__ + "static/media/industries.ab97f191.svg";